export default {
  SET_PROFILE_DATA (state, data) {
    state.profile = data
  }
}
